import theme from '@/src/config/theme'
import styled from 'styled-components'

import {Image} from '@/src/shared/ui/image'
import KitModal from '@/src/shared/ui/modal'

export const Icon = styled(Image)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`

export const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;

  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(255, 204, 8, 0.75);
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    transition: opacity 0.25s ease;
    z-index: 5;
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }

  @media (max-width: 767.98px) {
    aspect-ratio: 291 / 218;

    & > img:not(${Icon}) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

export const Title = styled.div`
  color: ${theme.colors.textDark};
  text-shadow: ${theme.colors.textShadow};
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  transform: translate(0, -25%);

  opacity: 0;
  font-size: 1.75rem;
  font-weight: 450;

  ${Wrapper}:hover & {
    z-index: 5;

    transform: unset;
    transition:
      opacity,
      transform 0.5s ease;
    opacity: 1;
  }

  @media (max-width: 767.98px) {
    font-size: 1rem;
  }
`

export const Modal = styled(KitModal)`
  &.ant-modal {
    padding-bottom: unset;
    transform-origin: unset;
  }

  & .ant-modal-content {
    padding: unset;
    height: 500px;

    iframe {
      width: 100%;
      min-height: 500px;
      height: 100%;
      border-color: #ffcc08;
    }
  }

  & button[aria-label='Close'] {
    border-radius: 50%;
    background: #ffcc08;

    &:hover {
      background: black;
      color: white;
    }
  }

  //& .modal-body {
  //  padding: unset;
  //  min-height: 500px;
  //
  //}
  //
  //& [aria-label="Close"] {
  //  background: #ffcc08;
  //
  //  svg {
  //    border-color: white;
  //    stroke: black;
  //  }
  //}
  //
  //& [aria-label="Close"]:active {
  //  background: #cfa607;
  //}
`
